import { connect } from 'react-redux';
import { SafeRentDescription } from './SafeRentDescription';
import { prefetchFormState } from '../../store/deal-rent';
import { IState } from '../../store';

interface ISafeRentDescription {
  id: number;
}

export function mapStateToProps(state: IState): ISafeRentDescription {
  return {
    id: state.offerData.offer.id,
  };
}

export const SafeRentDescriptionContainer = connect(
  mapStateToProps,
  { openModal: prefetchFormState },
)(SafeRentDescription);
